import { reactive } from 'vue';
import axios from 'axios';
// Ensure this path matches where your server.js is located
import { API_URL } from '../server';

// 1. Create a reactive state object
export const scheduleStore = reactive({
  items: {},            // Stores the organized group list
  raspisaniyaitem: {},  // Stores specific schedule details (legacy/single item)
  todaySchedule: null,
  currentSemester: null,
  tutorData: null,// Stores the result of get-today
  weekSchedule: [],     // <--- ADDED: Stores the result of get-week
  loading: false,
  error: null,
  user: null,
});

// Helper map to convert database IDs to View tab names
const LEVEL_MAP = {
  1: 'bachelor',
  2: 'specialist',
  3: 'magistr',
  4: 'Докторантура'
};

// 2. Define Actions as regular functions

// --- GET ALL GROUPS (Organized by Level) ---
export const fetchSchedule = async () => {
  scheduleStore.loading = true;
  scheduleStore.error = null;

  try {
    const response = await axios.get(API_URL + '/api/group');

    // The API returns { code: 200, data: [...] }
    const rawGroups = response.data.data;

    // Initialize empty structure matching View expectations
    const organizedData = {
      bachelor: [],
      specialist: [],
      magistr: [],
      phd: []
    };

    if (Array.isArray(rawGroups)) {
      rawGroups.forEach(group => {
        // Get the category key (e.g., 1 -> 'bachelor')
        const levelKey = LEVEL_MAP[group.groupLevel];

        // Only process if it matches a known level
        if (levelKey && organizedData[levelKey]) {

          const courseName = `${group.groupCourse} курс`;

          // Find if this course ("1 курс") already exists in this level
          let courseSection = organizedData[levelKey].find(c => c.year === courseName);

          // If not, create it
          if (!courseSection) {
            courseSection = { year: courseName, list: [] };
            organizedData[levelKey].push(courseSection);
          }

          // Add the group to the list
          courseSection.list.push({
            id: group.id,
            title: group.name
          });
        }
      });

      // Sort the courses (1 курс, 2 курс, etc.) numerically
      Object.keys(organizedData).forEach(key => {
        organizedData[key].sort((a, b) => parseInt(a.year) - parseInt(b.year));
      });
    }

    scheduleStore.items = organizedData;

  } catch (err) {
    console.error('Fetch error:', err);
    scheduleStore.error = 'Failed to load schedule.';
  } finally {
    scheduleStore.loading = false;
  }
};

// --- GET SCHEDULE BY DATE ---
export const fetchScheduleByDate = async (groupId, dateString) => {
  scheduleStore.loading = true;
  scheduleStore.error = null;

  try {
    // 1. Create the base params object
    const params = {
      groupId: groupId
    };

    // 2. Conditionally add date if it exists
    if (dateString) {
      params.date = dateString;
    }

    // URL: /api/schedule/get-by-date?groupId=1 (&date=... only if provided)
    const response = await axios.get(API_URL + '/api/schedule/get-by-date', {
      params: params
    });

    // We reuse todaySchedule since the data structure is the same
    scheduleStore.todaySchedule = response.data.data;

  } catch (err) {
    console.error('Fetch by date error:', err);
    scheduleStore.error = 'Failed to load schedule for date.';
    // If error or empty, clear the list
    scheduleStore.todaySchedule = [];
  } finally {
    scheduleStore.loading = false;
  }
};

export const fetchTutors = async () => {
  scheduleStore.loading = true;
  scheduleStore.error = null;

  try {
    // URL: /api/schedule/get-by-date?groupId=1&date=2025-12-07
    const response = await axios.get(API_URL + '/api/tutor', {
    });

    // We reuse todaySchedule since the data structure is the same
    scheduleStore.tutorData = response.data.data;

  } catch (err) {
    console.error('Fetch by date error:', err);
    scheduleStore.error = 'Failed to load schedule for date.';
    // If error or empty, clear the list
    scheduleStore.todaySchedule = [];
  } finally {
    scheduleStore.loading = false;
  }
};

// --- GET SCHEDULE BY ID (Legacy) ---
export const fetchRaspisaniya = async (id) => {
  scheduleStore.loading = true;
  scheduleStore.error = null;

  try {
    const response = await axios.get(API_URL + '/api/schedule/' + id);
    scheduleStore.raspisaniyaitem = response.data.data;
  } catch (err) {
    console.error('Fetch error:', err);
    scheduleStore.error = 'Failed to load schedule.';
  } finally {
    scheduleStore.loading = false;
  }
};

// --- GET TODAY'S SCHEDULE ---
export const fetchTodaySchedule = async (groupId) => {
  scheduleStore.loading = true;
  scheduleStore.error = null;

  try {
    const response = await axios.get(API_URL + '/api/schedule/get-today', {
      params: { groupId: groupId }
    });

    scheduleStore.todaySchedule = response.data.data;

  } catch (err) {
    console.error('Fetch today error:', err);
    scheduleStore.error = 'Failed to load today schedule.';
  } finally {
    scheduleStore.loading = false;
  }
};

export const fetchTutorScheduleByDate = async (tutorId, date) => {
  scheduleStore.loading = true;
  scheduleStore.todaySchedule = []; // Clear previous data

  try {
    // 1. Start with the base URL and mandatory tutorId
    let url = `${API_URL}/api/schedule/tutor-get-by-date?tutorId=${tutorId}`;

    // 2. Only add the date parameter if 'date' is truthy (not undefined or null)
    if (date) {
      url += `&date=${date}`;
    }

    const response = await fetch(url);
    const res = await response.json();

    if (res.code === 200) {
      scheduleStore.todaySchedule = res.data;
    }
  } catch (error) {
    console.error("Error fetching tutor schedule by date:", error);
  } finally {
    scheduleStore.loading = false;
  }
};


export const fetchCurrentSemestr = async () => {
  scheduleStore.loading = true;
  scheduleStore.currentSemester = []; // Clear previous data

  try {
    // 1. Start with the base URL and mandatory tutorId
    let url = `${API_URL}/api/semester/get-current-semester`;



    const response = await fetch(url);
    const res = await response.json();

    if (res.code === 200) {
      scheduleStore.currentSemester = res.data;
    }
  } catch (error) {
    console.error("Error fetching tutor schedule by date:", error);
  } finally {
    scheduleStore.loading = false;
  }
};


export const fetchTutorWeekSchedule = async (tutorId, offset) => {
  scheduleStore.loading = true;
  scheduleStore.weekSchedule = []; // Clear previous data
  try {
    const response = await fetch(`${API_URL}/api/schedule/tutor-get-week?tutorId=${tutorId}&offset=${offset}`);
    const res = await response.json();
    if (res.code === 200) {
      scheduleStore.weekSchedule = res.data;
    }
  } catch (error) {
    console.error("Error fetching tutor week schedule:", error);
  } finally {
    scheduleStore.loading = false;
  }
};

// --- GET WEEK SCHEDULE (Fixed Race Condition) ---
let lastWeekRequestId = 0;

export const fetchWeekSchedule = async (groupId, offset) => {
  // Generate a unique ID for this specific click
  const requestId = ++lastWeekRequestId;

  // 1. CRITICAL: Clear old data immediately so user sees the change
  scheduleStore.weekSchedule = [];

  scheduleStore.loading = true;
  scheduleStore.error = null;

  try {
    console.log(`Fetching week offset: ${offset} (ReqID: ${requestId})`);

    const response = await axios.get(API_URL + '/api/schedule/get-week', {
      params: {
        groupId: groupId,
        offset: offset
      }
    });

    // 2. CRITICAL: Only update state if this is still the LATEST request
    if (requestId === lastWeekRequestId) {
        scheduleStore.weekSchedule = response.data.data || [];
        console.log("Week data updated for offset:", offset);
    } else {
        console.warn("Ignored stale response for offset:", offset);
    }

  } catch (err) {
    // Only handle error if it's the latest request
    if (requestId === lastWeekRequestId) {
        console.error('Fetch week error:', err);
        scheduleStore.error = 'Failed to load week schedule.';
        scheduleStore.weekSchedule = [];
    }
  } finally {
    // Only turn off loading if it's the latest request
    if (requestId === lastWeekRequestId) {
        scheduleStore.loading = false;
    }
  }
};

// --- CREATE ITEM ---
export const createScheduleItem = async (newItem) => {
  scheduleStore.loading = true;
  try {
    const response = await axios.post(API_URL + '/api/schedule', newItem);
    console.log("Item created", response.data);
  } catch (err) {
    console.error('Create error:', err);
    scheduleStore.error = 'Failed to create item.';
  } finally {
    scheduleStore.loading = false;
  }
};

// --- DELETE ITEM ---
export const deleteScheduleItem = async (id) => {
  try {
    await axios.delete(API_URL + '/api/schedule/' + id);
  } catch (err) {
    console.error('Delete error:', err);
    scheduleStore.error = 'Failed to delete item.';
  }
};



export const getMe = async () => {
  const token = localStorage.getItem('token');

  if (!token) {
    throw new Error('No token found');
  }

  // 1. Return the axios promise so the component can handle .then() or .catch()
  const response = await axios.get(API_URL + '/api/user/me', {
    headers: {
      Authorization: `Bearer ${token}` // Ensure token is sent
    }
  });

  return response.data.data; // Returns the user object
}
